module.exports = __webpack_public_path__ + "img/AdminActionGoalsSp.a19cf24b.png";